import { createTheme } from '@mui/material/styles';

const theme = createTheme ({
    typography: {
        fontFamily: `'ProximaNova', sans-serif`
    }
})

export default theme;